import React from "react";

export const ActionsContext = React.createContext();